
import PageHeader from '../components/Layout/PageHeader.vue';
    export default {
        data() {
            return {
                educations: [],
                categories: [],
                selected_category: "",
                loading: true,
                order: "desc",
                pages: [],
                current_page: 1
            };
        },
        watch: {
            selected_category: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.pages = [];
                    this.current_page = 1;
                }
            }
        },
        created() {
            const page = this.$route.query.page;
            if(page) this.current_page = page;

            this.fetchEducations();
            this.fetchCategories();
        },
        mounted() {
            this.setPageFromHistory();
            console.log(this.$route.fullPath);
        },
        methods: {
            async fetchCategories() {
                const results = await this.$axios.get("/categories");
                this.categories = results.data.data;
            },
            changePage(page) {
                // console.log(page);
                this.current_page = page;
                this.fetchEducations();
                window.scrollTo(0, 0);

                const url = new URL(window.location.href);
                url.searchParams.set('page', page);
                window.history.replaceState(null, null, url); // or pushState
            },
            previousPage() {
                if (this.current_page !== 1) {
                    this.current_page -= 1;
                    this.fetchEducations();
                }
            },
            nextPage() {
                if (this.current_page < this.pages.length) {
                    this.current_page += 1;
                    this.fetchEducations();
                }
            },
            async fetchEducations() {
                this.loading = true;
                this.pages = [];
                const results = await this.$axios.get(`/educations?page=${this.current_page}&results=9&category=${this.selected_category}&order=${this.order}`);
                this.educations = results.data.results;
                this.pages = results.data.numberOfPages;
                this.loading = false;
                // .then((response) => {
                //     this.educations = response.data.results;
                //     this.pages = response.data.numberOfPages
                //     this.loading = false;
                // })
                // .catch(error => {
                //     // console.error("There was an error!", error);
                // });
            },

            setPageFromHistory(){
                if(window){
                    const url = new URL(window.location.href);
                    const page_param = url.searchParams.get("page");
                    if(page_param){
                        this.current_page = Number(page_param);
                    }
                }
            }
        },
        components: { PageHeader }
    }
